import React from 'react';
import {
  useMediaQuery,
  useTheme,
  Box,
  Typography,
  Tooltip,
  IconButton
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const Heading = ({
  title,
  styles = {},
  action = null,
  helperText = null,
  sideW = '100px'
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const sideWidth = sideW;

  return (
    <Box mb={2} sx={{ ...styles }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row-reverse',
          alignItems: 'center',
          justifyContent: isMobile ? 'center' : 'space-between',
          px: 2.5,
          py: 1.25,
          borderBottom: '1px solid #eee',
          position: 'relative',
          gap: isMobile ? 1.5 : 0
        }}
      >
        {!isMobile && !action && (
          <Box
            sx={{
              width: sideWidth,
              height: '1.4rem',
              visibility: 'hidden'
            }}
          />
        )}

        <Box
          sx={{
            textAlign: 'center',
            fontSize: '1.4rem',
            fontWeight: 600,
            color: '#333',
            lineHeight: 1.3,

            whiteSpace: 'normal',
            overflowWrap: 'break-word',
            wordBreak: 'normal',
            maxWidth: isMobile ? '100%' : '70%',
            mx: 'auto',

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1
          }}
        >
          {title}
          {helperText && (
            <Tooltip
              title={helperText}
              arrow
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: '#f1f5f9',
                    color: '#374151',
                    fontSize: '12px',
                    borderRadius: '6px',
                    maxWidth: 280,
                    p: 0.5
                  }
                }
              }}
            >
              <Box
                component="span"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  color: '#666',
                  fontSize: '0.85rem',
                  position: 'relative',
                  top: '-4px'
                }}
              >
                <InfoOutlinedIcon fontSize="inherit" />
              </Box>
            </Tooltip>
          )}
        </Box>

        {/* Action */}
        {action && (
          <Box
            sx={{
              width: isMobile ? '100%' : sideWidth,
              display: 'flex',
              justifyContent: isMobile ? 'center' : 'flex-end',
              alignItems: 'center',
              mt: isMobile ? 1 : 0
            }}
          >
            {action}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Heading;
